module.exports = __webpack_public_path__ + "static/media/khaled.21d0a398.jpg";